import { Link } from "react-router-dom";
import { Mail, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT, NAV } from "../lib/site";

export const Footer = () => (
  <footer className="relative border-t border-white/10 bg-surface/40" data-testid="site-footer">
    <div className="container-x py-16 lg:py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
            Rent-to-rent solutions and supported housing for vulnerable people across the North
            West of England — British-built, people-first, and locally accountable.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">Explore</h4>
          <ul className="mt-4 space-y-3">
            {NAV.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  data-testid={`footer-nav-${item.label.toLowerCase()}`}
                  className="text-sm text-slate-400 hover:text-white transition-colors"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">Contact</h4>
          <ul className="mt-4 space-y-4">
            <li>
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="footer-email"
                className="group block rounded-2xl border border-white/10 bg-gradient-to-br from-surface2/80 to-surface/50 p-5 transition-all duration-300 hover:border-amber/40 hover:-translate-y-0.5"
              >
                <span className="flex items-center gap-2 text-xs font-mono uppercase tracking-[0.18em] text-amber">
                  <Mail className="h-4 w-4" /> Email us
                </span>
                <span className="mt-2 block font-display font-bold text-lg text-white break-words group-hover:text-amber transition-colors">
                  {CONTACT.email}
                </span>
                <span className="mt-3 inline-flex items-center gap-1.5 text-sm text-slate-400 group-hover:text-white transition-colors">
                  Send us a message
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
                </span>
              </a>
            </li>
            <li className="flex items-center gap-2 text-xs text-slate-500">
              <span className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse" />
              Replies within one working day
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-white/10 space-y-2 text-xs leading-relaxed text-slate-500">
        <p data-testid="footer-legal" className="text-slate-400">
          <span className="font-semibold text-slate-300">Insight Properties</span> trading as{" "}
          <span className="font-semibold text-slate-300">INSITE IQ LTD</span>, a company registered
          in England and Wales.
        </p>
        <p>Company number 17335358 · Registered office: 66 Paul Street, London, England, EC2A 4NA</p>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 pt-3">
          <span>© {new Date().getFullYear()} INSITE IQ LTD. All rights reserved.</span>
          <span className="text-slate-500">Made in Britain 🇬🇧 · North West England</span>
        </div>
      </div>
    </div>
  </footer>
);
